import { render } from "./CWidgetSimple.vue?vue&type=template&id=046a581a"
import script from "./CWidgetSimple.vue?vue&type=script&lang=js"
export * from "./CWidgetSimple.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__